export default __webpack_public_path__ + "static/media/AHT_Icon.3eb64670.png";